module.exports = "/_next/static/images/OneApi@2x-66f918e1d61b1f1e2f13c978a4272a98.webp";